// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Detail_mainContainer__2WuSx"};